import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export type AlertType = 'info' | 'warning' | 'error';

const ICONS: Record<AlertType, string> = {
  info: 'info_outline',
  warning: 'warning_amber',
  error: 'error_outline',
};

/**
 * An alert with an optional heading, showing the projected content as its
 * message. `testId` is suffixed with `-title`, `-message` and `-close` for
 * its parts.
 */
@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
  host: {
    class: 'flex gap-2',
    '[class.info]': 'type() === "info"',
    '[class.warning]': 'type() === "warning"',
    '[class.error]': 'type() === "error"',
    '[attr.data-test-id]': 'testId()',
  },
})
export class AlertComponent {
  readonly type = input<AlertType>('info');
  readonly heading = input<string>();
  /** Shows a close button, which emits `dismiss` */
  readonly dismissible = input(false, { transform: booleanAttribute });
  readonly testId = input<string>();

  readonly dismiss = output();

  readonly icon = computed(() => ICONS[this.type()]);

  readonly partTestId = (part: string) =>
    this.testId() ? `${this.testId()}-${part}` : null;
}
